/**
 * SOAP History Service
 * Frontend service for SOAP history operations
 */

import apiService from './api.service';

const soapHistoryService = {
  /**
   * Get all SOAP history with pagination
   */
  getAll: async (page = 1, limit = 20, filters = {}) => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...filters
    });

    return apiService.get(`/soap-history?${params.toString()}`);
  },

  /**
   * Get single SOAP history entry by ID
   */
  getById: async (id) => {
    return apiService.get(`/soap-history/${id}`);
  },

  /**
   * Delete single SOAP history entry
   */
  delete: async (id) => {
    return apiService.delete(`/soap-history/${id}`);
  },

  /**
   * Delete all SOAP history entries
   */
  deleteAll: async () => {
    return apiService.delete('/soap-history');
  },

  /**
   * Get SOAP history statistics
   */
  getStats: async () => {
    return apiService.get('/soap-history/stats');
  }
};

export default soapHistoryService;
